import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles, FetchDownloads } from 'actions';
import {
	GetClustersNamesRequest,
	GenerateReportRequest,
} from '../requests/ReportsKpisRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_CLUSTERS_NAMES_RAN = 'GET_CLUSTERS_NAMES_RAN';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetClustersNames = value => ({
	type: GET_CLUSTERS_NAMES_RAN,
	clustersNames: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetClustersNames = () => async dispatch => {
	await GetClustersNamesRequest()
		.then(response => {
			dispatch(onGetClustersNames(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GenerateReport = (userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate) => async dispatch => {
	await GenerateReportRequest(userId, clusterName, preStartDate, preEndDate, postStartDate, postEndDate)
		.then(response => {
			dispatch(FetchDownloads(userId, 'ReportKpis'));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

